import React, { useState } from 'react';
import Modal from './Modal';
import Authentication from '../authentication';
export default function AuthorizableModal(_ref) {
  var appProps = _ref.appProps,
    authorizableScreen = _ref.authorizableScreen,
    extraParams = _ref.extraParams;
  return /*#__PURE__*/React.createElement(Modal, {
    visible: true,
    mode: "medium",
    elementsClass: "content-center",
    theme: "body-bg",
    closeModal: function closeModal() {
      window.location.href = appProps.rootPath;
    }
  }, /*#__PURE__*/React.createElement(Authentication, {
    appProps: appProps,
    authorizableRedirectionLink: appProps.redirectAfterAuthPath,
    authorizableRedirectionCompanyLink: appProps.redirectAfterRegisterAsCompanyPath,
    authorizableScreen: authorizableScreen,
    extraParams: extraParams
  }));
}